import type { ComponentType } from 'react';

import { GenericCardStack } from './images/GenericCardStack.tsx';
import { GoogleDriveCardStack } from './images/GoogleDriveCardStack.tsx';
import { MicrosoftSuiteCardStack } from './images/MicrosoftSuiteCardStack.tsx';

export type CardStackProps = { testId?: string };

// Products whose stack shows one logo per card, so each ships its own artwork.
const bespokeCardStacks: Record<string, ComponentType<CardStackProps> | undefined> = {
	drive: GoogleDriveCardStack,
	sharepoint: MicrosoftSuiteCardStack,
};

// Every other product uses the generic stack, with its own logo drawn on the front card.
export const getCardStackComponent = (appId: string): ComponentType<CardStackProps> =>
	bespokeCardStacks[appId] ?? GenericCardStack;

// A bespoke stack already carries its logos, so drawing `iconUrl` on the artwork would repeat them.
export const shouldDrawIconOnStack = (appId: string): boolean => !(appId in bespokeCardStacks);
